/*******************************************************************************
 * Initial state
 */
const initialState = {
    locales: [ {
        'label': 'Arabic (Saudi Arabia) - العربية',
        'code': 'ar-SA',
        'dir': 'rtl'
    }, {
        'label': 'Chinese (China) - 简体中文',
        'code': 'zh-CN',
        'dir': 'ltr'
    }, {
        'label': 'Chinese (Taiwan) - 繁體中文',
        'code': 'zh-TW',
        'dir': 'ltr'
    }, {
        'label': 'Danish (Denmark) - Dansk (Danmark)',
        'code': 'da-DK',
        'dir': 'ltr'
    }, {
        'label': 'Dutch (Netherlands)',
        'code': 'nl-NL',
        'dir': 'ltr'
    }, {
        'label': 'English (United Kingdom) ',
        'code': 'en-GB',
        'dir': 'ltr'
    }, {
        'label': 'English (United States)',
        'code': 'en-US',
        'dir': 'ltr'
    }, {
        'label': 'French (Canada) - Français du Canada',
        'code': 'fr-CA',
        'dir': 'ltr'
    }, {
        'label': 'French (France) - Français',
        'code': 'fr-FR',
        'dir': 'ltr'
    }, {
        'label': 'German (Germany) - Deutsch',
        'code': 'de-DE',
        'dir': 'ltr'
    }, {
        'label': 'Indonesian (Indonesia) - Bahasa',
        'code': 'id-ID',
        'dir': 'ltr'
    }, {
        'label': 'Italian (Italy) - Italiano',
        'code': 'it-IT',
        'dir': 'ltr'
    }, {
        'label': 'Japanese (Japan) - 日本語',
        'code': 'ja-JP',
        'dir': 'ltr'
    }, {
        'label': 'Korean (South Korea) - 한국어',
        'code': 'ko-KR',
        'dir': 'ltr'
    }, {
        'label': 'Polish (Poland) - Polski',
        'code': 'pl-PL',
        'dir': 'ltr'
    }, {
        'label': 'Portuguese (Brazil) - Português do Brasil',
        'code': 'pt-BR',
        'dir': 'ltr'
    }, {
        'label': 'Russian (Russia) - Русский',
        'code': 'ru-RU',
        'dir': 'ltr'
    }, {
        'label': 'Spanish (Mexico) - Español (México)',
        'code': 'es-MX',
        'dir': 'ltr'
    }, {
        'label': 'Spanish (Spain) - Español (España)',
        'code': 'es-ES',
        'dir': 'ltr'
    }, {
        'label': 'Turkish (Turkey) - Türkçe',
        'code': 'tr-TR',
        'dir': 'ltr'
    }, {
        'label': 'Thai - ไทย[ประเทศไทย]',
        'code': 'th-TH',
        'dir': 'ltr'
    }, {
        'label': 'Vietnamese - Tiếng Việt [Việt Nam]',
        'code': 'vi-VN',
        'dir': 'ltr'
    } ]
};

/*******************************************************************************
 * Non-async action types
 */
export const types = {
};

/*******************************************************************************
 * Reducer
 */
export default function globalizationReducer( state = initialState, action ) {
    switch ( action.type ) {
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export const actions = {
};